/**
 * Moves the current page to an external OAuth authorization URL.
 *
 * Cards call this browser boundary after the backend creates a signed URL. The OAuth provider is
 * the next step and returns the browser to ModernLoop through the configured callback.
 */

/** Starts an OAuth redirect in the current browser tab. */
export function navigateToOauth(url: string): void {
  window.location.assign(url);
}
